import { Box } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

export const ExpansionToggle = ({ isExpanded }: { isExpanded: boolean }) => {
  return (
    <Box
      sx={theme => ({
        width: 34,
        height: 34,
        borderRadius: '50%',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.text.primary,
        cursor: 'pointer',
        userSelect: 'none'
      })}
    >
      {isExpanded ? <RemoveIcon sx={{ fontSize: 18 }} /> : <AddIcon sx={{ fontSize: 18 }} />}
    </Box>
  );
};
